<template>
	<div class="SocialResponsibilityBox">
		<img class="SocialResponsibilityHeadImg" :src="headImg">
    <sr-box :dt='scDatas' :id="0"></sr-box>
    <sr-box :dt='scDatas2' :id="0"></sr-box>
    <sr-box :dt='scDatas3' :id="0"></sr-box>
    <sr-box :dt='scDatas4' :id="0" v-show="false"></sr-box>

    <div class="homeBotTxt">
      <p>Copyright ©2018 思考乐教育</p>
      <div>
        <router-link to="/LegalDeclaration">法律声明</router-link>
        <span class="l">|</span>
        <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}">校区导航</router-link>
      </div>
    </div>  
	</div>
</template>
<script>
// import '../../../static/js/swiper.min.js'
// import socialSwiper from '@/components/socialResponsibility/socialSwiper.vue'

export default {
  name: 'SocialResponsibility',
  data () {
    return {
      headImg: '',
      scDatas:[],
      scDatas2:[],
      scDatas3:[],
      scDatas4:[]
    }
  },
  created(){
     this.axios.get(this.$root.baseUrl+'/wap/responsibility/resList?category=5003001')
    .then(res=>{
      this.scDatas = res.data.newsList;
      console.log(res)
    })
    .catch(e=>{
      console.log(e)
    })

    this.axios.get(this.$root.baseUrl+'/wap/responsibility/resList?category=5003002')
    .then(res=>{
      this.scDatas2 = res.data.newsList;
      console.log(res)
    })
    .catch(e=>{
      console.log(e)
    })

    this.axios.get(this.$root.baseUrl+'/wap/responsibility/resList?category=5003003')
    .then(res=>{
      this.scDatas3 = res.data.newsList;
      console.log(res)
    })
    .catch(e=>{
      console.log(e)
    })   
    this.$nextTick(function(){
         this.axios.get(this.$root.baseUrl+'/wap/responsibility/resList?category=5003002')
        .then(res=>{
          this.scDatas4 = res.data.newsList;
        }) 
        .catch(e=>{
          console.log(e)
        })  
    })

    this.axios.get(this.$root.baseUrl+'/wap/responsibility/resBanner')
    .then(res=>{
      this.headImg = res.data.url;
      console.log(res.data)
    })
    .catch(e=>{
      console.log(e)
    })
  } 
}
</script>
<style>
	
.SocialResponsibilityBox{
	width: 100%;
  height: 100%;
  margin: 3.2rem auto 0;
}	
.SocialResponsibilityHeadImg{
  width: 100%;
}
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>


// WEBPACK FOOTER //
// src/components/socialResponsibility/SocialResponsibility.vue